"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  props: {
    questions: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      visible: 'true'
    };
  }
};